// extracted by mini-css-extract-plugin
module.exports = {"boxcontent":"styles_boxcontent__1Gvr7","cell":"styles_cell__3puG2"};